import { Preferences } from './WebPreferences';

const RATING_PREFS = {
  SESSION_COUNT: 'rating_sessionCount',
  NEVER_ASK: 'rating_neverAsk',
  LAST_ASKED: 'rating_lastAsked',
};

const SESSIONS_BEFORE_FIRST_ASK = 3;
const SESSIONS_BETWEEN_ASKS = 10;

let sessionCount = 0;
let neverAsk = false;
let lastAskedAt = 0;

export async function initRating() {
  const [countRes, neverRes, lastRes] = await Promise.all([
    Preferences.get({ key: RATING_PREFS.SESSION_COUNT }),
    Preferences.get({ key: RATING_PREFS.NEVER_ASK }),
    Preferences.get({ key: RATING_PREFS.LAST_ASKED }),
  ]);
  sessionCount = parseInt(countRes.value) || 0;
  neverAsk = neverRes.value === 'true';
  lastAskedAt = parseInt(lastRes.value) || 0;
}

export async function recordGameOver() {
  sessionCount++;
  await Preferences.set({ key: RATING_PREFS.SESSION_COUNT, value: String(sessionCount) });
}

export function shouldAskForRating() { return false; }
export async function markAsked() {}
export async function markNeverAsk() { neverAsk = true; }
export function openPlayStoreListing() {}
